import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacy-agb',
  templateUrl: './privacy-agb.component.html',
  styleUrls: ['./privacy-agb.component.scss'],
})
export class PrivacyAgbComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
